import { Fragment } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableRow, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const fontFamily = '"Inter", sans-serif';

const ProposalViewSystemWarranties = ({ arr, handleChange, system_index }) => (
  <Fragment>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, mt: 4 }}>
      <VerifiedUserIcon sx={{ fontSize: 20, color: '#0d3c61' }} />
      <Typography
        sx={{
          fontFamily,
          fontWeight: 600,
          fontSize: 14,
          color: '#1a1a1a',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        Warranties
      </Typography>
    </Box>

    <Box
      sx={{
        backgroundColor: '#f8f9fa',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <Table size="small">
        <TableBody>
          {arr.map((el, idx) =>
            el.flexibleItems.length > 0 && (
              <Fragment key={idx}>
                {el.flexibleItems.length < 2 ? (
                  // Single warranty item
                  <TableRow
                    sx={{
                      '&:last-child td': { borderBottom: 0 },
                    }}
                  >
                    <TableCell
                      sx={{
                        fontFamily,
                        fontSize: 13,
                        color: '#333',
                        py: 1.5,
                        borderBottom: '1px solid #e0e0e0',
                      }}
                    >
                      {el.flexibleItems[0].item.description}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontFamily,
                        fontSize: 13,
                        fontWeight: 600,
                        color: '#0d3c61',
                        py: 1.5,
                        borderBottom: '1px solid #e0e0e0',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {(() => { const y = el.flexibleItems[0].years || el.flexibleItems[0].item.years; return isNaN(y) ? y : `${y} Years`; })()}
                    </TableCell>
                  </TableRow>
                ) : (
                  // Multiple warranty options
                  <TableRow>
                    <TableCell colSpan={2} sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
                      <Typography
                        sx={{
                          fontFamily,
                          fontSize: 12,
                          color: '#666',
                          mb: 1,
                        }}
                      >
                        Select a warranty option:
                      </Typography>
                      <FormControl fullWidth>
                        <RadioGroup
                          value={el.selectedItemIndex}
                          onChange={(event) => handleChange(event, system_index, 'warranties', el)}
                        >
                          {el.flexibleItems.map((item, item_index) => (
                            <FormControlLabel
                              value={item_index}
                              key={item_index}
                              control={
                                <Radio 
                                  size="small"
                                  sx={{ 
                                    color: '#0d3c61',
                                    '&.Mui-checked': { color: '#0d3c61' },
                                  }}
                                />
                              }
                              label={
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                  <Typography sx={{ fontFamily, fontSize: 13, color: '#333' }}>
                                    {item.item.description}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily,
                                      fontSize: 13,
                                      fontWeight: 600,
                                      color: '#0d3c61',
                                      ml: 2,
                                    }}
                                  >
                                    {(() => { const y = item.years || item.item.years; return isNaN(y) ? y : `${y} Years`; })()}
                                  </Typography>
                                </Box>
                              }
                              sx={{
                                m: 0,
                                py: 0.5,
                                width: '100%',
                                borderBottom: item_index < el.flexibleItems.length - 1 ? '1px solid #eee' : 'none',
                              }}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                )}
              </Fragment>
            )
          )}
        </TableBody>
      </Table>
    </Box>
  </Fragment>
);

export default ProposalViewSystemWarranties;
